/* Maattabel-pop-up (productpagina 2.0).
   Twee handelingen: openen en sluiten. De rest doet <dialog> zelf, inclusief
   Escape, de verduistering en het vasthouden van de toetsenbordfocus. */
(function () {
  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-ck-maattabel-open]');
    if (opener) {
      var venster = document.getElementById(opener.getAttribute('data-ck-maattabel-open'));
      if (venster && typeof venster.showModal === 'function') {
        event.preventDefault();
        venster.showModal();
      }
      return;
    }

    var sluiter = event.target.closest('[data-ck-maattabel-sluit]');
    if (sluiter) {
      var open = sluiter.closest('dialog');
      if (open) open.close();
      return;
    }

    /* Klik naast het venster sluit ook. Een dialog vangt die klik op zichzelf
       op, dus we kijken of het klikpunt buiten het kader ligt. */
    var dlg = event.target.closest('dialog.ck-maattabel__venster');
    if (dlg && event.target === dlg) {
      var r = dlg.getBoundingClientRect();
      var buiten =
        event.clientX < r.left || event.clientX > r.right ||
        event.clientY < r.top || event.clientY > r.bottom;
      if (buiten) dlg.close();
    }
  });
})();
